import { ReactNode } from 'react';

interface ProductListGridProps {
  children: ReactNode;
}

export function ProductListGrid({ children }: ProductListGridProps) {
  return (
    <ul className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
      {children}
    </ul>
  );
}
